<template>
	<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path fill-rule="evenodd" clip-rule="evenodd" d="M8.542 20.849a.2.2 0 0 1-.29 0l-1.12-1.173a.2.2 0 0 1 0-.276l7.074-7.4-7.074-7.4a.2.2 0 0 1 0-.276l1.12-1.173a.2.2 0 0 1 .29 0l8.326 8.71a.2.2 0 0 1 0 .277l-8.326 8.71Z" fill="#00ABEF"/>
	</svg>
</template>

<script>
export default {
	props: {
		alt: String
	}
};
</script>
